<mode-field-list-toolbar
  [readOnly]="readOnly"
  [chartObjectType]="chartObjectType"
  (createCalcField)="onCreateCalcField()"
  (searchTermChanged)="onSearchTermChanged($event)"
>
</mode-field-list-toolbar>
<div class="section">
  <h4>Dimensions</h4>
  <ng-container *ngIf="originalDimensions.length !== 0">
    <ng-container *ngIf="dimensions.length !== 0; else dimEmptyList">
      <ul class="list-unstyled dimension-list">
        <li *ngFor="let attr of dimensions; trackBy: $attrId">
          <mode-field-list-attr
            [readOnly]="readOnly"
            [attr]="attr"
            [hasLocalCalcNameError]="localCalcDuplicatesColumnName(attr)"
            [hasParentCalcNameError]="parentCalcHasDuplicateLocalCalcName(attr)"
            [queryRunToken]="queryRunToken"
            [view]="view"
            (dragStart)="dragstart($event, attr)"
            (dragEnd)="dragend()"
            (editCalcField)="onEditCalcField($event)"
            (viewCalcField)="onViewCalcField($event)"
            (duplicateCalcField)="onDuplicateCalcField($event)"
            (removeCalcField)="onRemoveCalcField($event)"
            (applyFieldColor)="onApplyFieldColor($event)"
            (applyFieldFormat)="onApplyFieldFormat($event)"
            (applyDefaultAgg)="onApplyDefaultAgg($event)"
            [isFromImportedDataset]="isFromImportedDataset"
            [chartObjectType]="chartObjectType"
          ></mode-field-list-attr>
        </li>
      </ul>
    </ng-container>
    <ng-template #dimEmptyList>
      <div class="empty-list">No dimensions found</div>
    </ng-template>
  </ng-container>
</div>
<div class="section">
  <h4>Measures</h4>
  <ng-container *ngIf="originalMeasures.length !== 0">
    <ng-container *ngIf="measures.length !== 0; else measureEmptyList">
      <ul class="list-unstyled measure-list">
        <li *ngFor="let attr of measures; trackBy: $attrId" attr.data-test="measures-{{ attr.attrName }}">
        <mode-field-list-attr
          [readOnly]="readOnly"
          [attr]="attr"
          [hasLocalCalcNameError]="localCalcDuplicatesColumnName(attr)"
          [hasParentCalcNameError]="parentCalcHasDuplicateLocalCalcName(attr)"
          [view]="view"
          (dragStart)="dragstart($event, attr)"
          (dragEnd)="dragend()"
          (editCalcField)="onEditCalcField($event)"
          (viewCalcField)="onViewCalcField($event)"
          (duplicateCalcField)="onDuplicateCalcField($event)"
          (removeCalcField)="onRemoveCalcField($event)"
          (applyFieldColor)="onApplyFieldColor($event)"
          (applyFieldFormat)="onApplyFieldFormat($event)"
          (applyDefaultAgg)="onApplyDefaultAgg($event)"
          [chartObjectType]="chartObjectType"
          [isFromImportedDataset]="isFromImportedDataset"
          [queryRunToken]="queryRunToken"
        ></mode-field-list-attr>
        </li>
      </ul>
    </ng-container>
    <ng-template #measureEmptyList>
      <div class="empty-list">No measures found</div>
    </ng-template>
  </ng-container>
</div>
